<template>
  <div>
    <b-modal
      :ref="'modalObsServico'"
      hide-footer
      centered
      no-close-on-backdrop
    >
      <template #modal-title>
        <h4>Adicione o complemento desse serviço</h4>
        <span class="sub-title-modal">Esse complemento será apresentado junto com a descrição do serviço no PDF da proposta e na Omie</span>
      </template>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Complemento">
            <b-input
              v-model="observacaoTag"
              autofocus
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col cols="auto">
          <b-btn
            class="btn btn-success "
            variant="none"
            @click="salvarTag(observacaoTag)"
          >
            Salvar
          </b-btn>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<style lang="scss">

.tags {
  display: flex;
  align-self: center;
  height: fit-content;

  .badge-outline-primary {
    border: 1px solid var(--primary) !important;
    background-color: transparent;
    color: var(--primary) !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(27rem);
  }

  .link {
    // padding: 0.2rem + 0.2rem;
    border-radius: 4px 0 0 4px;
    cursor: pointer;

    &:hover {
      text-decoration: underline var(--primary);
    }
  }

  .remove {
    padding: 0.2rem !important;
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
    border-radius: 0 4px 4px 0;
  }
}
</style>

<script>

export default {
  name: 'ModalComplemento',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    itemEdit: {
      type: Number,
      default: null,
    },
    itemRemove: {
      type: Number,
      default: null,
    },
    indexSave: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      observacaoTag: null,
      servicos: [],
      removeItem: null,
      editItem: null,
      saveIndex: null,
      indexServico: this.indexSave,
    }
  },
  watch: {
    value(newValeu, oldValue) {
      if (newValeu !== oldValue) {
        this.servicos = newValeu
      }
    },
    indexSave(newValeu, oldValue) {
      if (newValeu !== oldValue) {
        this.indexServico = newValeu
      }
    },
  },
  created() {
    this.servicos = this.value
    this.indexServico = this.indexSave
  },
  methods: {
    show() {
      this.$refs.modalObsServico.show()
    },
    hide() {
      this.$refs.modalObsServico.hide()
    },
    salvarTag(obs) {
      this.servicos[this.indexServico].index = this.indexServico
      this.$set(this.servicos[this.indexServico], 'tagComplemento', obs)
      this.$refs.modalObsServico.hide()
      this.observacaoTag = null
    },
    editarTag(item) {
      if (item.code) {
        this.indexServico = this.servicos.findIndex(obj => obj.code === item.code)
      } else {
        this.indexServico = this.servicos.findIndex(obj => obj.id === item.id)
      }
      this.observacaoTag = item.tagComplemento
      this.$refs.modalObsServico.show()
    },
    RemoveTag(item) {
      let indexServico
      if (item.code) {
        indexServico = this.servicos.findIndex(obj => obj.code === item.code)
      } else {
        indexServico = this.servicos.findIndex(obj => obj.id === item.id)
      }
      this.$set(this.servicos[indexServico], 'tagComplemento', '')
      this.observacaoTag = null
    },
  },
}
</script>
